export default __webpack_public_path__ + "static/media/G_wdt_c_cap_0.3dba297c.mp3";